module.exports = __webpack_public_path__ + "static/media/mw.80badc4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/mw.png
// module id = 1934
// module chunks = 0